import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  ButtonBar, ErrorMessage, Input,
  ModalFormHeader,
  ScreenHeader
} from '../../components';

import { NewWillContext } from '.';

export function NewWillAddDebtorScreen() {
  const navigate = useNavigate();

  const { newWill, setNewWill } = React.useContext(NewWillContext);

  const [ error, setError ] = React.useState('');

  const handleBack = useCallback(() => {
    navigate('../debt-forgiveness');
  }, [ navigate ]);

  const handleNext = useCallback(() => {
    const debtorFirstName = (document.getElementById('debtor-first-name') as HTMLInputElement).value;
    const debtorLastName = (document.getElementById('debtor-last-name') as HTMLInputElement).value;
    const amountOwed = (document.getElementById('debtor-amount') as HTMLInputElement).value;
    const description = (document.getElementById('debtor-description') as HTMLInputElement).value;
    const streetAddress = (document.getElementById('debtor-street-address') as HTMLInputElement).value;
    const city = (document.getElementById('debtor-city') as HTMLInputElement).value;
    const state = (document.getElementById('debtor-state') as HTMLInputElement).value;
    const zip = (document.getElementById('debtor-zip') as HTMLInputElement).value;

    if (!debtorFirstName)
      return setError('Debtor first name is required.');
    if (!debtorLastName)
      return setError('Debtor last name is required.');
    if (!amountOwed || isNaN(Number(amountOwed)) || Number(amountOwed) <= 0)
      return setError('Valid amount owed is required.');
    if (!description)
      return setError('Description is required.');

    const debtor = {
      firstName: debtorFirstName,
      lastName: debtorLastName,
      amountOwed: Number(amountOwed),
      description,
    };

    const address = {
      address1: streetAddress,
      city,
      state,
      zip
    };

    navigate('../debt-forgiveness');
  }, [ navigate, newWill, setNewWill ]);

  return (
    <div className="new-will-add-debtor-screen screen">
      <ScreenHeader 
        title="Add Debtor"
        description="Provide details about the debtor"
        handleBack={handleBack} 
        steps={6} 
        step={5}
      />
      
      <div className="form-container">
        <ModalFormHeader
          icon="person"
          header="Debtor Information"
        />
        <Input
          id="debtor-first-name"
          label="Debtor First Name"
          placeholder="Enter debtor's first name"
          type="text"
        />
        <Input
          id="debtor-last-name"
          label="Debtor Last Name"
          placeholder="Enter debtor's last name"
          type="text"
        />
        <Input
          id="debtor-email"
          label="Debtor Email"
          placeholder="Enter debtor's email"
        />
        <Input
          id="debtor-phone"
          label="Debtor Phone"
          placeholder="Enter debtor's phone number"
        />
      </div>

      <div className="form-container">
        <ModalFormHeader
          icon="money_off"
          header="Debt Details"
        />
        <Input
          id="debtor-amount"
          label="Amount Owed"
          placeholder="Enter amount owed"
          type="number"
        />
        <Input
          id="debtor-description"
          label="Description"
          placeholder="Enter a description"
          type="text"
        />
      </div>

      <div className="form-container">
        <ModalFormHeader
          icon="location_on"
          header="Debtor Address"
        />
        <Input
          id="debtor-street-address"
          label="Street Address"
          placeholder="Enter debtor's street address"
          type="text"
        />
        <Input
          id="debtor-city"
          label="City"
          placeholder="Enter debtor's city"
          type="text"
        />
        <Input
          id="debtor-state"
          label="State"
          placeholder="Enter debtor's state"
          type="text"
        />
        <Input
          id="debtor-zip"
          label="ZIP Code"
          placeholder="Enter debtor's ZIP code"
          type="number"
        />
      </div>

      <ErrorMessage message={error} />

      <ButtonBar
        handlePrimary={handleNext}
        primaryText="Continue"
      />
    </div>
  );
}